<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="normal"
  >
    <template #header>导出日期范围报告</template>
    <template #content>
      <el-form :model="form" label-width="150px" ref="form">
        <el-form-item label="店铺" prop="marketIds" :rules="[
            {required: true, message: '请选择店铺', trigger: ['change', 'blur']}
        ]">
          <gj-market-select
              multiple
              v-model="form.marketIds"
              width="220px"
              :clearable="false"
          ></gj-market-select>
        </el-form-item>

        <el-form-item required label="请求时间" prop="date">
          <gj-date-picker
              type="daterange"
              v-model="form.date"
              width="220px"
              :clearable="false"
              :max-day-length="59"
          ></gj-date-picker>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="confirm" type="primary">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../../minxins";
    import {subDays} from "date-fns";
    import {exportFinanceProfitReportSettlement} from "../../../../../../api/finance";
    import {convertToDate} from "../../../../../../utils/date.util";

    export default {
        name: "settlement-export",
        mixins: [modalMixIn],
        data() {
            return {
                form: {
                    marketIds: [],
                    date: [subDays(new Date(), 59), new Date()],
                }
            }
        },
        methods: {
            confirm() {
                if (this.formValidate()) {
                    exportFinanceProfitReportSettlement({
                        marketIds: this.marketIds,
                        startDate: convertToDate(this.form.date[0]),
                        endDate: convertToDate(this.form.date[1]),
                    });
                    this.$gjMessage.success("正在导出，请稍后");
                    this.$gjDestroy();
                }
            },
            formValidate() {
                let formValid = false;
                this.$refs.form.validate((valid) => {
                    formValid = valid;
                });
                return formValid;
            },
        }
    }
</script>

<style scoped>

</style>
